import React, { useCallback, useEffect, useState, useRef } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
// Data Lists
const PRODUCTS = [{
  title: 'Código Hormonal',
  editionLabel: 'Pack Hormonal — Edición Digital',
  price: '$17.990',
  thumbnailUrl: 'https://cdn.magicpatterns.com/uploads/2rZHzqC9K5dXyqh3uLNAM9/Ebook_Codigo_Hormonal.png'
}, {
  title: 'La Cocina Biohacker',
  editionLabel: 'Recetario de 28 Días',
  price: '$14.990',
  thumbnailUrl: 'https://cdn.magicpatterns.com/uploads/57cFcbL4WYzHS2UcAo4FP1/Bono_1.png'
}, {
  title: 'Protocolo de Movimiento',
  editionLabel: 'Entrenamiento Cíclico',
  price: '$9.990',
  thumbnailUrl: 'https://cdn.magicpatterns.com/uploads/9YzPZxXzLEZd1tsyG7iDp9/Bono_2.png'
}];
const NAMES = ['Valentina', 'Camila', 'Lucía', 'Martina', 'Sofía', 'Isabella', 'Catalina', 'Florencia', 'Agustina', 'Milagros', 'Julieta', 'Rocío', 'Abril', 'Pilar', 'Carolina', 'Daniela', 'Victoria', 'Guadalupe', 'Celeste', 'Antonella', 'Bianca', 'Renata', 'Micaela', 'Lara', 'Mora'];
const CITIES = ['Buenos Aires', 'Córdoba', 'Rosario', 'Mendoza', 'San Miguel de Tucumán', 'La Plata', 'Mar del Plata', 'Salta', 'Santa Fe', 'San Juan', 'Resistencia', 'Neuquén', 'Posadas', 'Bahía Blanca', 'Paraná', 'San Luis', 'Corrientes', 'San Salvador de Jujuy', 'Río Cuarto', 'Tandil'];
interface ToastData {
  id: number;
  name: string;
  city: string;
  product: (typeof PRODUCTS)[0];
  timeAgo: number;
}
export function RecentPurchaseToast() {
  const [toast, setToast] = useState<ToastData | null>(null);
  const nameHistoryRef = useRef<string[]>([]);
  const timeoutRef = useRef<NodeJS.Timeout | null>(null);
  const isMountedRef = useRef(true);
  // Helper to get random item from array
  const getRandomItem = <T,>(arr: T[]): T => arr[Math.floor(Math.random() * arr.length)];
  // Helper to get random number in range
  const getRandomInt = (min: number, max: number) => Math.floor(Math.random() * (max - min + 1)) + min;
  const generateToast = useCallback(() => {
    // Select name avoiding last 10
    let availableNames = NAMES.filter(n => !nameHistoryRef.current.includes(n));
    if (availableNames.length === 0) {
      availableNames = NAMES; // Reset if exhausted
      nameHistoryRef.current = [];
    }
    const name = getRandomItem(availableNames);
    // Update history
    nameHistoryRef.current = [name, ...nameHistoryRef.current].slice(0, 10);
    const city = getRandomItem(CITIES);
    const product = getRandomItem(PRODUCTS);
    const timeAgo = getRandomInt(1, 15); // 1-15 mins ago
    return {
      id: Date.now(),
      name,
      city,
      product,
      timeAgo
    };
  }, []);
  const scheduleNextToast = useCallback(() => {
    if (!isMountedRef.current) return;
    const delay = getRandomInt(8000, 15000); // 8-15 seconds
    timeoutRef.current = setTimeout(() => {
      if (!isMountedRef.current) return;
      const newToast = generateToast();
      setToast(newToast);
      // Hide after 4 seconds
      setTimeout(() => {
        if (isMountedRef.current) {
          setToast(null);
          scheduleNextToast(); // Schedule next one after hiding
        }
      }, 4000);
    }, delay);
  }, [generateToast]);
  useEffect(() => {
    isMountedRef.current = true;
    // Initial delay of 3 seconds
    const initialTimeout = setTimeout(() => {
      if (!isMountedRef.current) return;
      const firstToast = generateToast();
      setToast(firstToast);
      // Hide first toast after 4s
      setTimeout(() => {
        if (isMountedRef.current) {
          setToast(null);
          scheduleNextToast();
        }
      }, 4000);
    }, 3000);
    return () => {
      isMountedRef.current = false;
      if (timeoutRef.current) clearTimeout(timeoutRef.current);
      clearTimeout(initialTimeout);
    };
  }, [generateToast, scheduleNextToast]);
  return <AnimatePresence data-id="element-114">
      {toast && <motion.div key={toast.id} initial={{
      y: 80,
      opacity: 0,
      x: '-50%'
    }} animate={{
      y: 0,
      opacity: 1,
      x: '-50%'
    }} exit={{
      y: 80,
      opacity: 0,
      x: '-50%'
    }} transition={{
      duration: 0.4,
      ease: 'easeOut'
    }} className="fixed bottom-4 left-1/2 z-50 w-[90%] max-w-sm md:max-w-md bg-white rounded-xl shadow-lg border border-[#E8D8E0] p-3 flex items-center gap-3" data-id="element-115">
          <img src={toast.product.thumbnailUrl} alt={toast.product.title} className="w-12 h-12 rounded-lg object-cover bg-gray-100 flex-shrink-0" data-id="element-116" />

          <div className="flex-1 min-w-0" data-id="element-117">
            <div className="flex justify-between items-start" data-id="element-118">
              <p className="text-sm font-semibold text-[#2D2028] truncate" data-id="element-119">
                {toast.name}{' '}
                <span className="font-normal text-[#6B5B65]" data-id="element-120">
                  en {toast.city}
                </span>
              </p>
              <span className="text-xs text-[#6B5B65] whitespace-nowrap ml-2" data-id="element-121">
                hace {toast.timeAgo} min
              </span>
            </div>

            <p className="text-xs text-[#4A3845] truncate" data-id="element-122">
              compró{' '}
              <span className="font-medium" data-id="element-123">{toast.product.editionLabel}</span>
            </p>

            <p className="text-xs font-bold text-[#E8638B] mt-0.5" data-id="element-124">
              {toast.product.price}
            </p>
          </div>
        </motion.div>}
    </AnimatePresence>;
}